import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=efa04bd6&scoped=true&lang=pug"
import script from "./layer.vue?vue&type=script&lang=js"
export * from "./layer.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=efa04bd6&prod&lang=scss&scoped=true&external"
import style1 from "./layer.vue?vue&type=style&index=1&id=efa04bd6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa04bd6",
  null
  
)

export default component.exports